import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useMovieTrailer from '../hooks/useMovieTrailer';
import useMovieImage from '../hooks/UseMovieImage';

const Videobg = ({movieId, posterPath}) => {
  const trailerVideo=useSelector((store) => store.movie?.trailerVideo);
  useMovieTrailer(movieId)
  useMovieImage(movieId)
  const movieImage=useSelector((store)=>store.movie?.movieImage);

    const [showVideo, setShowVideo] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowVideo(true);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const fallbackBg = /^https?:\/\//.test(posterPath || '') ? posterPath : null;

  return (
   <div className=" relative w-full h-screen overflow-hidden bg-black">
    {movieImage?.file_path && (
     <img
        src={`https://image.tmdb.org/t/p/original${movieImage.file_path}`}
        alt="Movie background"
        className="absolute top-0 left-0 w-full h-full object-cover"
      />
   )}
    {!movieImage?.file_path && fallbackBg && (
      <>
        <img
          src={fallbackBg}
          alt="Movie background"
          className="absolute inset-0 w-full h-full object-cover animate-kenburns"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40"></div>
      </>
    )}
    {showVideo && trailerVideo?.key && (
      <iframe
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[max(100vw,177.78vh)] h-[max(100vh,56.25vw)] pointer-events-none"
        src={`https://www.youtube.com/embed/${trailerVideo.key}?autoplay=1&mute=1&controls=0&loop=1&playlist=${trailerVideo.key}&start=0&end=30&modestbranding=1&rel=0&showinfo=0`}
        title="YouTube trailer"
        allow="autoplay; encrypted-media"
        allowFullScreen
      ></iframe>
    )}
    </div>
  )
}

export default Videobg